import Proxy from '../Proxy';

class NegativeProxy extends Proxy {
  /**
   * The constructor for the EstimationComplexProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('negatives', parameters);
  }
}

export default NegativeProxy;
